@if (tabGroups && tabGroups.length > 0) {
  <div class="tabs-wrapper">
    <button
      class="button"
      mat-button
      (click)="isOpen = !isOpen"
      type="button"
      cdkOverlayOrigin
      #trigger="cdkOverlayOrigin">
      <mat-icon aria-hidden="false" aria-label="Example home icon"> {{ isOpen ? 'menu_open' : 'menu' }}</mat-icon>
      <span class="menu-info">Menu</span>
    </button>
    <!-- This template displays the overlay content and is connected to the button -->
    <ng-template
      cdkConnectedOverlay
      [cdkConnectedOverlayOrigin]="trigger"
      [cdkConnectedOverlayOpen]="isOpen"
      (backdropClick)="isOpen = !isOpen"
      [cdkConnectedOverlayHasBackdrop]="true">
      <div class="overlay-content">
        <div class="tab-group-label">
          Menu
          <mat-divider></mat-divider>
        </div>
        @for (group of tabGroups; track group) {
          <div>
            <div>{{ group.name }}</div>
            <ul>
              @for (tab of group.items; track tab) {
                <li>
                  <a href="javascript:void(0)" (click)="navigate(baseUrl + '/' + tab.code)">{{ tab.label }}</a>
                </li>
              }
            </ul>
          </div>
        }
      </div>
    </ng-template>
  </div>
}
